import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import { Box } from '@mui/system';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DraftOrderDialog = ({open, handleClose, handlePayment}) => {
  const [draftName, setDraftName] = React.useState("");
  const [disabled, setDisabled] = React.useState(false);

  React.useEffect(() => {
    const validate = async() => {
      setDisabled(draftName.trim().length === 0)
    };
    validate();
  },[draftName]);

  const draftHandle = async() => {
    handlePayment('Cash', '', '', true, draftName)
    resetField();
  };
  const handleCloseDialog = async() => {
    handleClose();
    resetField();
  };
  const resetField = async() => {
    setDraftName("")
  };
  return (
    <div>
      <Dialog open={open} onClose={handleCloseDialog} TransitionComponent={Transition} sx={{width: "100vw"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseDialog}><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Draft Order</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Draft Name" variant="standard" fullWidth value={draftName} onChange={(event)=> setDraftName(event.target.value)}/></Grid>
            <Grid item xs={12}><Button autoFocus variant="contained" disabled={disabled} onClick={draftHandle} fullWidth>Save</Button></Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default DraftOrderDialog
